import './ProductItem.css';

export default function ProductItem({item}) {
    return <div className="product-item">
        <div className="product-item-img">
            <img loading="lazy" src={item.image} alt={item.alt || item.name || 'Produkt'} />

        </div>
        <div className="product-item-name">
            {item.name}
        </div>
        <div className="product-item-amount">
            {item.amount} szt.
        </div>
        <div className="product-item-price">
            {Number(item.price).toFixed(2)} zł
        </div>
    </div>;
}
